const REGEX_SPECIAL_CHARACTERS = /[~!@#$%^&*()_|+\-=?;:",.<>{}[\]\/]/g;

export const escapeSpecialCharacters = (value) => {
  return value.replace(REGEX_SPECIAL_CHARACTERS, (match) => `\\${match}`);
}